/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { hasAnyAccess } from "helper/access-permission"
import Select from 'react-select'
import { useEffect, useState } from "react"
import { Controller, useForm } from 'react-hook-form'
import { UseAuth } from "hook/auth-hook"
import { RestUseCase } from "service/api/rest/rest-usecase"
import { Button, Col, Form, Row } from "react-bootstrap"
import ReportPage from "pages/layout/scrap/report-page"
import { ConfigTable } from "../../../@types/interfaces/table-interface"
import { EntityFieldReport } from "../../../@types/entity/field/report/field-report"
import { SelectOptionInterface } from "../../../@types/entity/interface/select-option-interface"
import ErrorNotAuthorizedPage from "pages/layout/error/error-not-authorized-page"
import { HeaderNavegationList } from 'helper/adapter/headerNavigation/header-navegation-adapter'
import { UseAlert } from 'hook/alert-hook'
import { getEnv } from 'helper/window-helper'
import { SelectContainer } from 'react-select/dist/declarations/src/components/containers'
import { SelectProvider } from 'components/select/provider-select-component'
import { useLoader } from "components/loader/loader-context";
import { handleRequest } from 'service/api/request-common'

interface FilterInputs {
    analiseRelatorioAgrupamento: string
    fornecedor: number
    status: string[]
    setores: number[]
    regionais: number[]
    filiais: string[]
    codigoItem: string
    modeloPrioritario: string
    inicioAgendamento: string
    fimAgendamento: string
}

export const ReportScrapFactory: React.FC = () => {

    const { showLoader, hideLoader } = useLoader();

    /**
    * 
    * 
    * 
    * 
    * 
    * 
    * 
    * 
    */
    /** CAMPOS DA TELA */
    const entityField: EntityFieldReport[] = [
        { name: "dn", labelTable: "DN", typeField: "text", align: "center" },
        { name: "nomeConcessionaria", labelTable: "Nome Concessionária", typeField: "text", align: "left" },
        { name: "codScrap", labelTable: "Cod Scrap", typeField: "number", align: "center" },
        { name: "numerosNotaFiscal", labelTable: "Número da(s) NF(s)", typeField: "text", align: "left" },
        { name: "dataCadastro", labelTable: "Data Cadastro", typeField: "date", align: "center" },
        { name: "status", labelTable: "Status", typeField: "text", align: "left" },
        { name: "reg", labelTable: "Reg", typeField: "text", align: "center" },
        { name: "setor", labelTable: "Setor", typeField: "text", align: "center" },
        { name: "inicioAgendamento", labelTable: "Inicio Agend.", typeField: "date", align: "center" },
        { name: "finalAgendamento", labelTable: "Final Agend.", typeField: "date", align: "center" },
        { name: "disponivel", labelTable: "Disponível (Crédito Stellantis)", typeField: "monetary", align: "right" },
        { name: "gasto", labelTable: "Gasto (Valor Scrap Itens Selecionados)", typeField: "monetary", align: "right" }
    ]
    const [entityFields] = useState<EntityFieldReport[]>(entityField)

    const checkboxStatusValues = [
        { label: "Aguardando CPV", value: "Aguardando CPV", checked: false },
        { label: "Aguardando CPV (Divergências)", value: "Aguardando CPV (Divergências)", checked: false },
        { label: "Processo em análise do Financeiro (Fábrica)", value: "Processo em análise do Financeiro (Fábrica)", checked: false },
        { label: "Aguardando Concessionária inserir NF (XML)", value: "Aguardando Concessionária inserir NF (XML)", checked: false },
        { label: "Aguardando Nota Fiscal CPV", value: "Aguardando Nota Fiscal CPV", checked: false },
        { label: "Programado para pagamento à Concessionária", value: "Programado para pagamento à Concessionária", checked: false },
        { label: "Processo Entregue (Em análise pela Fábrica)", value: "Processo Entregue (Em análise pela Fábrica)", checked: false },
        { label: "Aguardando Vendas (Divergências)", value: "Aguardando Vendas (Divergências)", checked: false },
        { label: "Cancelado", value: "Cancelado", checked: false },
        { label: "Pago (Creditado em Conta movimento do Dealer)", value: "Pago (Creditado em Conta movimento do Dealer)", checked: false },
    ]

    const [checkboxFields, setCheckboxFields] = useState(checkboxStatusValues)

    /** HEADER */
    const { setValue, getValues, register, handleSubmit, control, watch } = useForm<FilterInputs>()
    const [providerSelect, updateProviderSelect] = useState<SelectOptionInterface[]>()
    const [provider, updateProvider] = useState<SelectOptionInterface>()
    const [companieSelect, updateCompanieSelect] = useState<SelectOptionInterface[]>()
    const [companie, updateCompanie] = useState<number>()
    const [filialSelect, updateFilialSelect] = useState<SelectOptionInterface[]>()
    const [groupingSelect, updateGroupingSelect] = useState<SelectOptionInterface[]>()
    const [sectorsSelect, updateSectorsSelect] = useState<SelectOptionInterface[]>()
    const [sector, updateSector] = useState<number[]>()
    const [regionalSelect, updateRegionalSelect] = useState<SelectOptionInterface[]>()
    const [regional, updateRegional] = useState<SelectOptionInterface[]>([])


    /**
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     */
    /** TABELA */
    const [tableHeader, updateTableHeader] = useState<any[]>([])
    const [tableBody, updateTableBody] = useState<any[]>([])
    const [graphicData, updateGraphicData] = useState<any[]>()
    const clearTableBody = () => { updateTableBody([]) }

    /**
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     */
    /** CONFIGURACAO */
    const configTable: ConfigTable = {
        checkboxes: false,
        icons: false,
        buttonHeader: false,
        selectsTable: true,
        navegation: false,
        buttonFooter: false,
        pagination: false,
        planning: false,
        openModal: true
    }
    const ENDPOINT_REPORT = getEnv("REACT_APP_END_POINT_SCRAP")! + `/relatorio`
    const ENDPOINT_PROVIDER = getEnv("REACT_APP_END_POINT_PROVIDER")! + ``
    const ENDPOINT_SCRAP = getEnv("REACT_APP_END_POINT_PURCHASES_PROVIDER")! + ``
    const ENDPOINT_FILIAL = getEnv("REACT_APP_END_POINT_FILIAL")! + ``
    const ENDPOINT_SECTOR = getEnv("REACT_APP_END_POINT_SECTOR")! + ``
    const ENDPOINT_REGIONAL = getEnv("REACT_APP_END_POINT_REGIONAL")! + ``
    const ENDPOINT_COMPANIES = getEnv("REACT_APP_END_POINT_COMPANIES")! + ``



    const titlePage = "Relatório Scrap"

    /**
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     */
    /** CHAMADAS BACKEND */
    const { showAlert } = UseAlert()
    const [withError, updateWithError] = useState<boolean>(false)
    const [waiting, updateWaiting] = useState<boolean>(false)
    const get = async (modelFields: FilterInputs) => {
        showLoader();
        const agrupamentoSelected = watch("analiseRelatorioAgrupamento");
        if (agrupamentoSelected === undefined) {
            showAlert({
                show: true,
                content: 'Você deve selecionar um agrupamento.',
                color: 'danger',
                time: 2000,
            });
            hideLoader();
            return;
        }

        const fornecedorSelected = watch("fornecedor");
        if (fornecedorSelected === undefined) {
            showAlert({
                show: true,
                content: 'Você deve selecionar um fornecedor.',
                color: 'danger',
                time: 2000,
            });
            hideLoader();
            return;
        }

        clearTableBody()
        updateWaiting(true)

        let data = Object.fromEntries(Object.entries(modelFields).filter(([_, v]) => {
            if (v != null || v !== '')
                return v
        }))

        if (sector?.length === 0) {
            data.setores = []
        }
        if (!Array.isArray(data.filiais)) {
            delete data.filiais
        }

        await new RestUseCase(`${ENDPOINT_REPORT}`)
            .Post({
                data: data
            })
            .then(response => {
                if (response.statusCode === 200) {
                    updateTableHeader(entityFields.map((value) => { return { name: value.name, labelTable: value.labelTable, align: value.align } }))
                    const sumDisponivel = response.body.reduce((accumulator: any, object: { disponivel: any }) => {
                        return accumulator + object.disponivel;
                    }, 0);

                    const sumGasto = response.body.reduce((accumulator: any, object: { gasto: any }) => {
                        return accumulator + object.gasto;
                    }, 0);

                    updateGraphicData([{
                        name: 'disponivel x gasto',
                        Disponivel: Number(sumDisponivel),
                        Gasto: Number(sumGasto)
                    }])

                    showAlert({ show: true, content: "Relatório gerado com sucesso", color: "success", time: 2000 })
                    hideLoader();
                    updateTableBody(response.body)
                } else {
                    showAlert({ show: true, content: "Nenhum item retornado", color: "warning", time: 2000 })
                    hideLoader();
                    updateWithError(true)
                }
            })
            .catch(() => updateWithError(true))
        hideLoader();
        updateWaiting(false)
    }
    const handleSelectProvider = async () => {
        await new RestUseCase(ENDPOINT_PROVIDER)
            .Get()
            .then(response => {
                updateProviderSelect(response.body.map((value: any) => { return { value: value.id, label: value.nome } }))
            })
            .catch(() => updateWithError(true))
    }
    const handleSelectFilial = async (idCompanie?: number) => {
        let querie = `?`
        if (idCompanie)
            querie += `empresa=${idCompanie}&`
        if (provider)
            querie += `fornecedor=${provider.value}&`

        await new RestUseCase(ENDPOINT_FILIAL + querie)
            .Get()
            .then(response => {
                updateFilialSelect(response.body.map((value: any) => { return { value: value.id, label: value.nome } }))
            })
            .catch(() => updateWithError(true))
    }
    const handleSelectGrouping = async () => {
        updateGroupingSelect([
            { value: "REGIONAL", label: "REGIONAL" },
            { value: "SETOR", label: "SETOR" },
            { value: "FILIAL", label: "FILIAL" },
            { value: "SEMESTRAL", label: "SEMESTRAL" },
            { value: "ITEM", label: "ITEM" }
        ])
    }
    const handleSelectSectors = async (regionais?: SelectOptionInterface[]) => {
        if (provider !== null && provider !== undefined) {
            await new RestUseCase(ENDPOINT_SECTOR + `?idFornecedor=${provider.value}`)
                .Get()
                .then(response => {
                    if (regionais?.length !== 0) {
                        updateSectorsSelect(response.body.filter((value: any) => regionais?.includes(value.idRegional)).map((value: any) => {
                            return {
                                value: value.id, label: value.nome
                            }
                        })
                        )
                    } else {
                        updateSectorsSelect(response.body.map((value: any) => {
                            return {
                                value: value.id, label: value.nome
                            }
                        }))
                    }
                })
                .catch(() => updateWithError(true))
        }
    }
    const handleSelectRegional = async () => {
        if (provider !== undefined) {
            await new RestUseCase(ENDPOINT_REGIONAL + `?idFornecedor=${provider.value}`)
                .Get()
                .then(response => {
                    updateRegionalSelect(response.body.map((value: any) => { return { value: value.id, label: value.nome } }))
                })
                .catch(() => updateWithError(true))
        }
    }
    const handleSelectCompanie = async () => {
        await new RestUseCase(ENDPOINT_COMPANIES)
            .Get()
            .then(response => {
                updateCompanieSelect(response.body.map((value: any) => { return { value: value.id, label: value.nome } }))
            })
            .catch(() => updateWithError(true))
    }

    /**
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     */


    /**
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     */
    /** INICIO */
    useEffect(() => {
        updateSectorsSelect([])
        updateSector(undefined)
        updateRegionalSelect([])
        updateRegional([])
        updateFilialSelect([])
        updateCompanieSelect([])

        handleSelectSectors()
        handleSelectRegional()
        handleSelectFilial()
        handleSelectCompanie()
    }, [provider])

    useEffect(() => {
        updateSectorsSelect([])
        updateSector([])
        if (regional.length !== 0)
            handleSelectSectors(regional)
    }, [regional])

    useEffect(() => {
        updateFilialSelect([])
        if (companie)
            handleSelectFilial(companie)
    }, [companie])

    useEffect(() => {
        handleSelectProvider()
        handleSelectGrouping()
    }, [])

    /** VERIFICA PERMISSAO DE ACESSO */
    const { loggedUserData } = UseAuth()
    const [showScreen, updateShowScreen] = useState<boolean>(false)
    useEffect(() => {
        const roleScreen = HeaderNavegationList.filter(header => header.navTitle === "Scrap")[0].navItem.filter(item => item.title === "Relatório Scrap")[0].access

        if (hasAnyAccess(loggedUserData?.access, roleScreen)) {
            updateShowScreen(true)
        }

    }, [loggedUserData])

    const handleAllStatusCheckBox = (checked: boolean) => {
        if (checked) {
            const allValues = checkboxFields.map(cb => cb.value);
            setValue("status", allValues);
        } else {
            setValue("status", []);
        }
    };

    async function getExcel(): Promise<any> {
        const rawData = getValues();

        const data = Object.fromEntries(
            Object.entries(rawData).filter(([key, value]) => {
                if (Array.isArray(value)) return true; // mantém arrays vazios
                return value !== "" && value !== null && value !== undefined;
            })
        );
        if (!Array.isArray(data.filiais)) {
            delete data.filiais
        }

        const response = await new RestUseCase(`${ENDPOINT_SCRAP}/gerar-excel`).Post({
            responseType: 'blob',
            data: data
        });

        return handleRequest(response);

    }

    const onClickExportarExcel = async () => {
        showLoader();
        const agrupamentoSelected = watch("analiseRelatorioAgrupamento");
        if (agrupamentoSelected === undefined) {
            showAlert({
                show: true,
                content: 'Você deve selecionar um agrupamento.',
                color: 'danger',
                time: 2000,
            });
            hideLoader();
            return;
        }

        const fornecedorSelected = watch("fornecedor");
        if (fornecedorSelected === undefined) {
            showAlert({
                show: true,
                content: 'Você deve selecionar um fornecedor.',
                color: 'danger',
                time: 2000,
            });
            hideLoader();
            return;
        }

        try {
            const response = await getExcel()
            if (response.statusCode === 200 && response.body) {
                const url = window.URL.createObjectURL(new Blob([response.body]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Scrap.xlsx`);
                document.body.appendChild(link);
                link.click();
                link!.parentNode!.removeChild(link);
                showAlert({
                    show: true,
                    content: 'Exportado com sucesso',
                    color: 'success',
                    time: 2000,
                });
            }else{
                showAlert({
                show: true,
                content: 'Erro ao tentar fazer o download do relatório de scrap.',
                color: 'warning',
                time: 2000,
            });   
            }
            
        } catch (error) {
            console.error('Error downloading Excel file:', error);
            showAlert({
                show: true,
                content: 'Erro ao tentar fazer o download do relatório de scrap.',
                color: 'warning',
                time: 2000,
            });
        }

        hideLoader();
    }

    /**
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     * 
     */
    /** RENDERIZACAO */
    return (
        <>
            {showScreen ?

                <ReportPage
                    titlePage={titlePage}
                    entityFields={entityFields}
                    tableHeader={tableHeader}
                    tableBody={tableBody}
                    configTable={configTable}
                    withError={withError}
                    waiting={waiting}
                    graphic={graphicData && graphicData.length > 0 ? graphicData : undefined}
                >
                    <>
                        {/* Planejamento */}
                    </>
                    <>
                        <div className="d-flex justify-content-end">
                            <Button
                                variant="outline-primary"
                                className="d-flex align-items-center"
                                onClick={onClickExportarExcel}
                                size="sm"
                                disabled={!tableBody || tableBody.length === 0}
                            >
                                Exportar
                            </Button>
                        </div>

                        <form onSubmit={handleSubmit(get)} className="mt-0" noValidate>
                            <Row>
                                <Col md={3} >
                                    <Form.Label className="fw-bold">Agrupamentos:</Form.Label>
                                    <Controller
                                        name="analiseRelatorioAgrupamento"
                                        control={control}
                                        render={({ field: { onChange, value } }) => {
                                            return (<Select onChange={val => onChange(val?.value)} options={groupingSelect} placeholder="Selecione o Agrupamento" />)
                                        }}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="fw-bold">Fornecedor:</Form.Label>
                                    <Controller
                                        name="fornecedor"
                                        control={control}
                                        render={({ field: { onChange, value } }) => {
                                            return (<Select
                                                isClearable={true}
                                                value={provider}
                                                onChange={val => {
                                                    onChange(val?.value)
                                                    updateProvider(val ? val : undefined)
                                                }}
                                                options={providerSelect}
                                                placeholder="Selecione o Fornecedor"
                                            />)
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row>


                                <Col md={3}>
                                    <Form.Label>Regionais:</Form.Label>
                                    <Controller
                                        name="regionais"
                                        control={control}
                                        render={({ field: { onChange, value } }) => {
                                            return (
                                                <Select
                                                    isMulti
                                                    key={provider?.value}
                                                    options={regionalSelect}
                                                    onChange={val => {
                                                        let data = val.map((elements: any) => elements.value)
                                                        updateRegional(data)
                                                        onChange(data)
                                                    }}
                                                    placeholder="Selecione a regional"
                                                />
                                            )
                                        }}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Setores:</Form.Label>
                                    <Controller
                                        name="setores"
                                        control={control}
                                        render={({ field: { onChange, value } }) => {
                                            return (<Select
                                                key={regional[0] ? regional[0].value : -1}
                                                isMulti
                                                options={sectorsSelect}
                                                onChange={val => {
                                                    let data = val.map((elements: any) => elements.value)
                                                    updateSector(data)
                                                    onChange(data.length > 0 ? data : [])
                                                }}
                                                placeholder="Selecione o Setor" />)
                                        }}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Empresa:</Form.Label>
                                    <Select
                                        onChange={val => updateCompanie(val?.value)}
                                        options={companieSelect}
                                        placeholder="Selecione a Empresa"
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Filiais:</Form.Label>
                                    <Controller
                                        name="filiais"
                                        control={control}
                                        render={({ field: { onChange } }) => {
                                            return (<Select
                                                onChange={val => onChange(val?.value != null ? [String(val.value)] : [])}
                                                options={filialSelect}
                                                placeholder="Selecione a Filial"
                                            />)
                                        }}
                                    />
                                </Col>

                            </Row>
                            <Row className='mt-3'>

                                <Col md={3}>
                                    <Form.Label>Inicio do Agendamento:</Form.Label>
                                    <Col>
                                        <Form.Control type="date" {...register("inicioAgendamento")} />
                                    </Col>
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Fim do Agendamento:</Form.Label>
                                    <Col>
                                        <Form.Control type="date" {...register("fimAgendamento")} />
                                    </Col>
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Código do Item:</Form.Label>
                                    <Col>
                                        <Form.Control type="text" {...register("codigoItem")} />
                                    </Col>
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Modelo Prioritário:</Form.Label>
                                    <Col>
                                        <Form.Control type="text" {...register("modeloPrioritario")} />
                                    </Col>
                                </Col>
                            </Row>

                            <Controller
                                name="status"
                                control={control}
                                defaultValue={[]}
                                render={({ field }) => (
                                    <>
                                        <Row md={12} className='mt-3'>
                                            <Col md={1}>
                                                <Form.Check
                                                    onChange={(e) => handleAllStatusCheckBox(e.currentTarget.checked)}
                                                    label="Todos"
                                                    type="checkbox"
                                                    checked={field.value.length === checkboxFields.length}
                                                />
                                            </Col>
                                        </Row>
                                        <Row md={12}>
                                            {checkboxFields.map((cb, index) => (
                                                <Col md={4}>
                                                    <Form.Check
                                                        key={index}
                                                        label={cb.label}
                                                        type="checkbox"
                                                        value={cb.value}
                                                        checked={field.value.includes(cb.value)}
                                                        onChange={(e) => {
                                                            const newValue = e.target.checked
                                                                ? [...field.value, cb.value]
                                                                : field.value.filter(v => v !== cb.value);
                                                            field.onChange(newValue);
                                                        }}
                                                    />
                                                </Col>
                                            ))}
                                        </Row>
                                    </>
                                )}
                            />

                            <div className="d-flex align-items-center justify-content-end mt-3">
                                <Button variant="primary" size="sm" type="submit">Aplicar</Button>
                            </div>
                        </form>
                    </>
                    <>
                        {/* Navegacao */}
                    </>
                    <>
                        {/* Footer */}
                    </>
                    <>
                        {/* modal item */}
                    </>
                </ReportPage>
                :
                <ErrorNotAuthorizedPage />
            }
        </>
    )

}
